import { render } from "./NonTheosMintedNfts.vue?vue&type=template&id=4c98844b&scoped=true"
import script from "./NonTheosMintedNfts.vue?vue&type=script&lang=js"
export * from "./NonTheosMintedNfts.vue?vue&type=script&lang=js"

import "@/Common/Styles/profilePanels.scss?vue&type=style&index=0&id=4c98844b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c98844b"]])

export default __exports__